import { Component, Input, Output, EventEmitter, ViewChild, OnInit, AfterViewInit } from '@angular/core';
@Component({
    selector: 'sanmarino-header',
    templateUrl: 'app.sanmarino.header.html'
})
export class SanMarinoHeaderComponent implements OnInit {
    @Input() SectionDetailsList: any;
    @Input() TestInfo: any;
    public SectionDetails: any;
    public quesCount: any;
    public Vdname: string;
    ngOnInit() {
        this.Vdname = window.location.pathname.split('/')[1];
    }
}


// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/Headers/Themes/SanMarino/app.sanmarino.ts